import React, { Dispatch, SetStateAction } from 'react'
import { ICategoryItem, IMenuItemActions, MenuListContentTypes, MenuListTypes, MyMenuContentTypes } from '../../../../../../../Interfaces/componentTypes';
import { IMenuItemResponce, IMenuListItem, MenuListResponce } from '../../../../../../../Interfaces/responseTypes';
import MenuList from '../MenuList/menuList';
import styles from './viewMenu.module.scss';

interface IProps {
    menuLoading: boolean;
    menu: MenuListResponce;
    itemOrderList?: number[] | [];
    itemActions?: IMenuItemActions[];
    categoryOrderList?: number[] | [];
    contentType: MenuListContentTypes;
    categoryItems: ICategoryItem | null;
    companyTitle?: string;
    companyId: number;
    setActiveContent: Dispatch<SetStateAction<MyMenuContentTypes>>;
    setContentType: Dispatch<SetStateAction<MenuListContentTypes>>;
    onSetMenuItemList: (data: IMenuListItem, title: string) => void;
    onOpenMenuItemInfoDialog: (categoryId: number, data: IMenuItemResponce, title: string) => void;
}

const ViewMenu: React.FC<IProps> = (props) => {
    const {
        menu,
        companyId,
        contentType,
        categoryItems,
        menuLoading,
        setContentType,
        categoryOrderList,
        itemOrderList,
        setActiveContent,
        onSetMenuItemList,
        onOpenMenuItemInfoDialog,
    } = props;

    return (
        <div className={styles.container} style={{
                    ...(contentType === MenuListContentTypes.ITEMS && {marginTop:"50px"}),
                  }}>
            <MenuList
                setContentType={setContentType}
                categoryItems={categoryItems!}
                contentType={contentType}
                menu={menu!}
                categoryOrderList={categoryOrderList}
                menuLoading={menuLoading}
                type={MenuListTypes.VIEW}
                setActiveContent={setActiveContent}
                companyId={companyId}
                companyTitle={props.companyTitle!}
                onSetMenuItemList={onSetMenuItemList}
                itemOrderList={itemOrderList}
                onOpenMenuItemInfoDialog={onOpenMenuItemInfoDialog}
            />
        </div>
    )
}

export default ViewMenu
